import React from "react";

import { IUserContext, UserContextConsumer } from "./UserContext";

export interface IWithUserContextProps extends IUserContext {}

export function withUserContext<P extends IWithUserContextProps>(WrappedComponent: React.ComponentType<P>) {
  return class WithUserContext extends React.Component<Omit<P, keyof IWithUserContextProps>> {
    renderContext = (context: IUserContext) => {
      return <WrappedComponent {...context} {...(this.props as P)} />;
    };

    render() {
      return <UserContextConsumer>{this.renderContext}</UserContextConsumer>;
    }
  };
}
